import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Observable, startWith, takeUntil } from 'rxjs';
import { BaseFormIoCustomComponent, FormioLoader } from 'dp-formio';
import { CommentsHistoryDialogComponent } from './comments-history-dialog/comments-history-dialog.component';

@Component({
  selector: 'comments-history-wrapper',
  templateUrl: './comments-history-wrapper.component.html',
  // styleUrls: ['./comments-history-wrapper.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [FormioLoader],
})
export class CommentsHistoryWrapperComponent
  extends BaseFormIoCustomComponent
  implements OnInit {
  @Input() data: any;
  @ViewChild('form') form: any;
  @Output() formSubmitted = new EventEmitter<any>();

  comments: any = [];

  disabled: boolean;

  openDialog: boolean;

  constructor(
    private translateService: TranslateService,

    public dialog: MatDialog
  ) {
    super();
  }

  ngOnInit(): void {
    this._listenToLanguageChanges();
  }
  private _listenToLanguageChanges() {
    (this.translateService.onLangChange as Observable<LangChangeEvent>)
      .pipe(
        takeUntil(this.destroy$),
        startWith({ lang: this.translateService.currentLang })
      )
      .subscribe((data) => {
        this.dir = null;
        setTimeout(() => {
          this.dir = data.lang == 'ar' ? 'rtl' : 'ltr';
        });
      });
  }

  showDialog() {
    this.dialog.open(CommentsHistoryDialogComponent, {
      width: 'min(80%,600px)',
      direction: this.dir,
      maxHeight: '90vh',
      autoFocus: false,
      restoreFocus: false,
      panelClass: ['position-relative', 'comments-history-dialog'],
      data: {
        options: this.customOptions,
        viewOnly: this.viewOnly,
        disabled: this.disabled,
        data: this.data
      },
    });
  }
}
